import * as React from "react";

import { cn } from "@/lib/utils";

type TextareaProps = React.ComponentProps<"textarea"> & {
  leftIcon?: React.ReactNode;
};

function Textarea({ className, leftIcon, ...props }: TextareaProps) {
  return (
    <div className="relative flex items-center">
      {leftIcon && (
        <span className="absolute left-3 top-4 pointer-events-none">
          {leftIcon}
        </span>
      )}
      <textarea
        data-slot="textarea"
        className={cn(
          "w-full rounded-xl bg-white/80 dark:bg-zinc-900/80 px-10 py-3 text-base shadow-sm border-2 transition-colors",
          "placeholder:text-zinc-500 dark:placeholder:text-zinc-300",
          "focus:outline-none resize-none",
          "border-gray-300 dark:border-zinc-700 focus:border-primary dark:focus:border-primary",
          "aria-invalid:border-red-500",
          "cursor-pointer",
          className,
        )}
        {...props}
      />
    </div>
  );
}

export { Textarea };
